default_colors = { 0:'No Sock', 1:'Navy', 2:'Scarlet', 3:'Columbia Blue', 4:'Grey', 5:'Graphite' };
colors = {
  'Air Force Blue': '%23006699', 
  'Black': '%23241f20', 
  'Brown': '%23452626', 
  'Bright Yellow': '%23ffff66',
  'Cardinal': '%23871728',
  'Columbia Blue': '%236699cc',
  'Cream':'%23FCFBE3',
  'Dark Gold': '%23ffcc33',
  'Dark Green': '%23005e35',
  'Dark Navy': '%23001D45',
  'Dark Royal': '%2300519c', 
  'Fuchsia': '%23dc81bb',
  'Gold': '%23FBCB13', 
  'Graphite': '%23454343', 
  'Grey': '%23b4b5b9',
  'Hot Pink': '%23ff3eb5',
  'Ivory': '%23fffff0',
  'Lavender': '%238a8ccd',
  'Lime': '%2398DEB3',
  'Marlin Teal': '%2300aabe',
  'Maroon': '%23500000',
  'Navy': '%23041c2c',
  'Neon Green': '%2300FF00',
  'Neon Yellow': '%23fef900',
  'Neon Orange': '%23ff4300',
  'Neon Gold': '%23fef900',
  'Old Gold': '%23A19244',
  'Orange': '%23ff6e00',
  'Pink': '%23ffccd7',
  'Purple': '%2338187f',
  'Royal': '%23005cb0',
  'Scarlet': '%23CE1934',
  'Scarlet Red': '%23CE1934',
  'Sedona Red': '%23a80027',
  'Teal': '%23008587',
  'Tennessee Orange': '%23ff8b00',
  'Texas Orange': '%23d95400',
  'Turquoise': '%2300a0cf',
  'Vegas Gold': '%23d5cc9d',
  'White': '%23FAFAFA',
  'Yellow': '%23fffb7d',
  'No Sock': '%23ffffff',
};


text_colors = {
  'Air Force Blue': '%23006699', 
  'Black': '%23241f20', 
  'Brown': '%23452626', 
  'Bright Yellow': '%23ffff66',
  'Cardinal': '%23871728',
  'Columbia Blue': '%236699cc',
  'Cream':'%23FCFBE3',
  'Dark Gold': '%23ffcc33',
  'Dark Green': '%23005e35',
  'Dark Navy': '%23001D45',
  'Dark Royal': '%2300519c', 
  'Fuchsia': '%23dc81bb',
  'Gold': '%23FBCB13', 
  'Graphite': '%23454343', 
  'Grey': '%23b4b5b9',
  'Hot Pink': '%23ff3eb5',
  'Ivory': '%23fffff0',
  'Lavender': '%238a8ccd',
  'Lime': '%2398DEB3',
  'Marlin Teal': '%2300aabe',
  'Maroon': '%23500000',
  'Navy': '%23041c2c',
  'Neon Green': '%2300FF00',
  'Neon Yellow': '%23fef900',
  'Neon Orange': '%23ff4300',
  'Neon Gold': '%23fef900',
  'Old Gold': '%23A19244',
  'Orange': '%23ff6e00',
  'Pink': '%23ffccd7',
  'Purple': '%2338187f',
  'Royal': '%23005cb0',
  'Scarlet': '%23CE1934',
  'Scarlet Red': '%23CE1934',
  'Sedona Red': '%23a80027',
  'Teal': '%23008587',
  'Tennessee Orange': '%23ff8b00',
  'Texas Orange': '%23d95400',
  'Turquoise': '%2300a0cf',
  'Vegas Gold': '%23d5cc9d',
  'White': '%23FAFAFA',
  'Yellow': '%23fffb7d',
  'No Sock': '%23ffffff',
};

var customerPhoto;

function update_colors(){
  if (customerPhoto) {
    var cc = 'customerPhoto[https://socksrock.herokuapp.com/' + customerPhoto + '],';
  } else { 
    var cc = '';
  }

  jQuery('select[name*="properties"]').each(function( index ) {
    var i = index + 1;
    cc = cc + 'color' + i.toString() + '[' + colors[jQuery(this).val()] + '],';
  });     




  jQuery('#1753966').each(function( index ) {
    var i = index + 1;
    cc = cc + 'fcolor' + i.toString() + '[' + text_colors[jQuery(this).val()] + '],';
  });  


  var PClevel = '';
  jQuery('.shappify_option_1738725').blur(function() {   
    var i = 1;
    PClevel = 'line' + i.toString() + '[' + [jQuery('.shappify_option_1738725').val()] + '],';


    var LayoutDropValue = $('#layout_shoes').find('option:selected').val();
    if ( LayoutDropValue == 'left' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + PClevel + "style[stirrup4inchpatFERight]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else if ( LayoutDropValue == 'front' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + PClevel + "style[stirrup4inchpatFEFront]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else if ( LayoutDropValue == 'buttom' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + PClevel + "style[stirrup4inchpatFEBack]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else{
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc  + PClevel +"style[stirrup4inchpatFELeft]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }

  });


  var Sizelevel = '';
  jQuery('.shappify_option_1754056').blur(function() {   
    var i = 1;
    Sizelevel = 'point' + i.toString() + '[' + [jQuery('.shappify_option_1754056').val()] + '],';

    var LayoutDropValue = $('#layout_shoes').find('option:selected').val();
    if ( LayoutDropValue == 'left' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + Sizelevel + PClevel + "style[stirrup4inchpatFERight]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else if ( LayoutDropValue == 'front' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + Sizelevel + PClevel + "style[stirrup4inchpatFEFront]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else if ( LayoutDropValue == 'buttom' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + Sizelevel + PClevel + "style[stirrup4inchpatFEBack]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else{
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc  + Sizelevel + PClevel +"style[stirrup4inchpatFELeft]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }


  });


  var SizeUp = 10;
  jQuery(document).on('click','.cus-arrow .up',function(){
    SizeUp = SizeUp + 10;

    var LayoutDropValue = $('#layout_shoes').find('option:selected').val();
    if ( LayoutDropValue == 'left' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + Sizelevel + PClevel + "myX[" + SizeUp + "]style[stirrup4inchpatFERight]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else if ( LayoutDropValue == 'front' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + Sizelevel + PClevel + "myX[" + SizeUp + "]style[stirrup4inchpatFEFront]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else if ( LayoutDropValue == 'buttom' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + Sizelevel + PClevel + "myX[" + SizeUp + "]style[stirrup4inchpatFEBack]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else{
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc  + Sizelevel + PClevel + "myX[" + SizeUp + "]style[stirrup4inchpatFELeft]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }


  });


  var SizeDown = 10;
  jQuery(document).on('click','.cus-arrow .down',function(){
    SizeDown = SizeDown + 10;


    var LayoutDropValue = $('#layout_shoes').find('option:selected').val();
    if ( LayoutDropValue == 'left' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + Sizelevel + PClevel + "myY[" + SizeDown + "]style[stirrup4inchpatFERight]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else if ( LayoutDropValue == 'front' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + Sizelevel + PClevel + "myY[" + SizeDown + "]style[stirrup4inchpatFEFront]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else if ( LayoutDropValue == 'buttom' ){
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + Sizelevel + PClevel + "myY[" + SizeDown + "]style[stirrup4inchpatFEBack]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }else{
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc  + Sizelevel + PClevel + "myY[" + SizeDown + "]style[stirrup4inchpatFELeft]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }

  });



  jQuery('#layout_shoes').on('change',function(){
    let layoutVal = jQuery(this).val();
    //alert(layoutVal);
    if ( layoutVal == 'left' ){
      if (cc) {
        document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + ",style[stirrup4inchpatFERight]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
        $("#product_pic").val(document.images.theImageA.src);
      }
    }else if ( layoutVal == 'front' ){
      if (cc) {
        document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + ",style[stirrup4inchpatFEFront]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
        $("#product_pic").val(document.images.theImageA.src);
      }
    }else if ( layoutVal == 'buttom' ){
      if (cc) {
        document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + ",style[stirrup4inchpatFEBack]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
        $("#product_pic").val(document.images.theImageA.src);
      }
    }else{
      if (cc) {
        document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + ",style[stirrup4inchpatFELeft]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
        $("#product_pic").val(document.images.theImageA.src);
      }
    }
  });


  var LayoutDropValue = $('#layout_shoes').find('option:selected').val();
  if ( LayoutDropValue == 'left' ){
    if (cc) {
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + ",style[stirrup4inchpatFERight]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }
  }else if ( LayoutDropValue == 'front' ){
    if (cc) {
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + ",style[stirrup4inchpatFEFront]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }
  }else if ( LayoutDropValue == 'buttom' ){
    if (cc) {
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + ",style[stirrup4inchpatFEBack]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }
  }else{
    if (cc) {
      document.images.theImageA.src = "https://socks.liquifire.com/socks?set=" + cc + ",style[stirrup4inchpatFELeft]&call=url[file:foundation/main]&scale=size[500]&sink&asdfasdfqwerqwerqwerqwer";
      $("#product_pic").val(document.images.theImageA.src);
    }
  }






}

function set_pic(pic){

  customerPhoto = pic;
  update_colors();  

}

jQuery(function() {
  jQuery('#shappify_add_to_cart_btn').click(function(){
    if(!(jQuery('#awarecb').is(':checked'))) {
      jQuery('#aware-error').css('display', 'block');
      return false;        
    }
  });

  jQuery('input#quantity[data-min]').each(function(){
    if (parseInt(this.value) < parseInt(jQuery(this).attr('data-min'))) 
      this.value = jQuery(this).attr('data-min');
  });

  jQuery('input#quantity[data-min]').change(function(){
    if (parseInt(this.value) < parseInt(jQuery(this).attr('data-min'))) 
      this.value = jQuery(this).attr('data-min');
  });

});

function watch(e) {
  var el = e;
  var intID = setInterval(function() {
    var display = jQuery(el).css('display');
    if (display == 'block') {
      // Setting default values for color lists
      jQuery('select[name*="properties"]').each(function( index ) {
        jQuery(this).val(default_colors[index]);
        if (!jQuery(this).val()) {
          jQuery(this).val(jQuery(jQuery(this).find('option')[1]).attr('value'));
        }
      });     
      update_colors();

      // Adding event hadlers for color change
      jQuery('select[name*="properties"]').change(function() {
        update_colors();
      });   


      // File upload code
      //                             jQuery('input[type=file]').each(function( ) {
      //                                 var fileInputContainer;
      //                                 var fileInput;
      //                                 var fileInputName;
      //                                 jQuery(this).change(function(){ 
      //                                   fileInputName = jQuery(this).attr('name');
      //                                   fileInputContainer = jQuery(this).parent();
      //                                   fileInput = jQuery(this);

      //                                   fileInput.attr('name', 'pic');
      //                                   jQuery('#sockform').append(fileInput);
      //                                   fileInputContainer.append(jQuery('#loader'));
      //                                   jQuery('#sockform').submit();

      //                                 });

      //                                var rpc = new easyXDM.Rpc({
      //                                   remote: "https://socksrock.herokuapp.com/form.html"
      //                                 }, {
      //                                     local: {
      //                                         returnUploadResponse: function(response){ 

      // 	                                          jQuery('#sockform').append(jQuery('#loader'));
      //     	                                      fileInputContainer.append(fileInput);
      //         	                                  fileInput.attr('name', fileInputName);
      //             	                              if (response.status == "success") {
      //                 	                              set_pic(response.msg);
      //                     	                      } else {
      //                         	                      fileInput.val('');
      //                             	                  set_pic('');
      //                                 	              alert(response.msg);
      //                                     	      }
      //                                         }
      //                                     }
      //                                 });                                  
      //                             });                           

      clearInterval(intID);
    }
  }, 1000);
};

$(function() {
  jQuery("[id*='shappify_custom_options_']").each(function() {
    watch(this);
  });
});

function watch_exist(e) {
  var el = e;
  var intID = setInterval(function() { 
    el = jQuery('#' + el);
    if (el) {
      el.change(function(){
        document.theImageA.src=jQuery('a[data-index=' + (el.get(0).selectedIndex+1) + ']').attr('data-original-image');
      } );                            
      clearInterval(intID);
    }
  }, 1000);
};
watch_exist('product-select-option-1');

